import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class SchoolService {

  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) { }

  addSchool(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.school.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'button' },
      isAuthRoutes: true
    });
  }

  allSchools(query: any) {
    return this.httpService.makeRequest({
      path: this.routes.school.retrieve,
      method: 'get',
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editSchool(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.school.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'button' },
      isAuthRoutes: true
    });
  }

  deleteSchool(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.school.delete,
      method: 'delete',
      options: { id, body: payload },
      loader: { type: 'button' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.school.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDeleteRoles(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.role.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  // Online Registration portal endpoints
  getSchoolBySlug(slug: string) {
    return this.httpService.makeRequest({
      path: this.routes.school.getSchoolOnline,
      method: 'get',
      endpointType: 'online',
      options: { id: slug },
      loader: { type: 'spinner' }
    });
  }
}
